import { NULL_VALUE } from '@constants';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IBenefits } from '@share/common-types';
import { Routes, Urls } from '@share/constants';
import { axiosInstance } from '@share/utils';
import { AppThunk } from '@share/utils';
import { isEmpty } from 'lodash';

export interface IBenefitsState {
  benefits: IBenefits | null;
  loading: boolean;
  error: string;
}

const initialState: IBenefitsState = {
  benefits: null,
  loading: false,
  error: '',
};

const benefitsSlice = createSlice({
  name: 'benefits',
  initialState,
  reducers: {
    setLoading: (state: IBenefitsState, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setError: (state: IBenefitsState, { payload }: PayloadAction<string>) => {
      state.error = payload;
    },
    setBenefits: (state: IBenefitsState, { payload }: PayloadAction<IBenefits | null>) => {
      state.benefits = payload;
    },
  },
});

export const benefitsActions = benefitsSlice.actions;

export const benefitsReducer = benefitsSlice.reducer;

export const getBenefits = (keyId: number): AppThunk => {
  return async (dispatch, getState) => {
    dispatch(benefitsActions.setLoading(true));

    try {
      const { loginStore, navigationMenuStore } = getState();
      const { account } = loginStore;
      const { items } = navigationMenuStore;

      const res = await axiosInstance.get(`${Urls.Benefits}/${keyId}`);

      let benefits = res.data ? { ...res.data } : null;

      const benefitItems = benefits?.items;
      const condoItem = benefitItems?.find((item: any) => item.title === 'Condos');
      const condoItemsFiltered = benefitItems?.filter((item: any) => item.title !== 'Condos');
      const condoItemChildItems = condoItem?.childItems;
      const weeklySpecialHash = account?.weeklySpecialHash;
      const isWeeklySpecialHash = account?.weeklySpecialHashEnabled && 
                                      ((!account?.weeklySpecialHashRsiSiteidList?.length && !account?.weeklySpecialHashRsiOrgidList?.length) || 
                                       (account?.weeklySpecialHashRsiSiteidList?.includes(items?.siteId?.toString()) || account?.weeklySpecialHashRsiOrgidList?.includes(items?.organizationId?.toString())));
      if (weeklySpecialHash &&
          weeklySpecialHash?.value &&
          !isEmpty(weeklySpecialHash?.value) &&
          isWeeklySpecialHash && 
          benefits &&
          condoItemChildItems?.length) {

        
        benefits = {
          items: [
            {
              ...condoItem,
              childItems: [
                ...condoItemChildItems,
                {
                  title: "Weekly Condo Specials - A short listing of unbeatable prices",
                  imageUrl: "https://rsistaticdata.s3.amazonaws.com/benefits/condo-specials.jpg",
                  description: "Typically 100+ condo specials selected especially for our members. They are first come, first-served and they go fast. So don't delay and call today.",
                  url: `${Routes.CondosWeeklySpecials}`,//?queryHash=${weeklySpecialHash?.value}`,
                  type: "condos"
                },
              ],
            },
            ...condoItemsFiltered,
          ],
        }
      }

      dispatch(benefitsActions.setLoading(false));
      dispatch(benefitsActions.setBenefits(benefits));
    } catch (error: any) {
      console.error(error);
      dispatch(benefitsActions.setError(error.toString()));
      dispatch(benefitsActions.setLoading(false));
    }
  };
};
